import { configureStore } from '@reduxjs/toolkit'
import { appApiSlice } from 'src/api/app-ApiSlice';
import { projectQuoteUiSlice } from 'src/api/project-quote-ui-slice';
import { uiSlice } from 'src/api/ui-slice';
import { projectsUiSlice } from 'src/api/projects-ui-slice';
import apiStatusListener from 'src/api/apiListenerMiddleware';
import { plannerUiSlice } from 'src/api/planner-ui-slice';

export const store = configureStore({
  reducer: {
    [appApiSlice.reducerPath]: appApiSlice.reducer,
    [projectQuoteUiSlice.reducerPath]: projectQuoteUiSlice.reducer,
    [uiSlice.reducerPath]: uiSlice.reducer,
    [projectsUiSlice.reducerPath]: projectsUiSlice.reducer,
    [plannerUiSlice.reducerPath]: plannerUiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware()
    .prepend(apiStatusListener)
    .concat(appApiSlice.middleware)
    ;
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch